import type { CSSProperties } from 'react'

/**
 * The custom property a loaded table carries and its stylesheet reads, so a table's rows are exactly as tall as
 * the placeholder rows that stood in for them and nothing below moves when the data arrives.
 */
export const TABLE_ROW_HEIGHT_CSS_PROPERTY = '--org-dashboard-table-row-height'

/*
 * Each height is the tallest cell content the table's rows hold (the stylesheet fixes its line heights), plus the
 * cell's vertical padding and its one-pixel rule, rounded up to the next 4px.
 */
export const DOMAINS_TABLE_ROW_HEIGHT = 52
export const ACQUISITION_TABLE_ROW_HEIGHT = 56
export const NOTIFICATIONS_TABLE_ROW_HEIGHT = 72

export const tableRowHeightStyle = (rowHeight: number): CSSProperties =>
    ({ [TABLE_ROW_HEIGHT_CSS_PROPERTY]: `${rowHeight}px` }) as CSSProperties
